import React, { useRef, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/css/style.css";
import { AuthContext } from "../Hook/AuthProvider";
import { ROUTES } from "../constants/routes";

function Profilepopup({ setUpgradeshow, wrapperRef, desktop }) {
  const { profileData } = useContext(AuthContext);
  const popupRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event) => {
      const refToCheck = wrapperRef?.current || popupRef.current;
      if (refToCheck && !refToCheck.contains(event.target)) {
        setUpgradeshow(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setUpgradeshow, wrapperRef]);

  const handleNavigate = (path) => {
    navigate(path);
    setUpgradeshow(false);
  };

  const isPro = profileData?.user_type === "pro";
  const fullName =
    [profileData?.first_name, profileData?.last_name].filter(Boolean).join(" ") ||
    "User";

  return (
    <div
      className={`popup-main-div${desktop ? " popup-main-div-desktop" : ""}`}
      ref={popupRef}
    >
      {/* User Info Header: Name + Pro badge (No Email) */}
      <div className="popup-div-detail">
        <div className="popup-div-name">
          <span className="popup-div-name-text" title={fullName}>
            {fullName}
          </span>
          {isPro && (
            <img
              src="/assets/images/pro-button-gradient-1.svg"
              alt="Pro"
              className="popup-pro-badge"
            />
          )}
        </div>
      </div>

      <div className="hrtag"></div>

      {/* 3 Compact Menu Options */}
      <div className="popup-button-div">
        {/* 1. Profile */}
        <div
          className="popup-div-profile"
          onClick={() => handleNavigate("/profile")}
        >
          <img
            src="/assets/images/profile-popup.svg"
            width={16}
            height={16}
            alt="profile"
          />
          <span>Profile</span>
        </div>

        {/* 2. Settings */}
        <div
          className="popup-div-setting"
          onClick={() => handleNavigate(ROUTES.BILLING)}
        >
          <img
            src="/assets/images/setting-icon.svg"
            width={16}
            height={16}
            alt="settings"
            onError={(e) => {
              e.currentTarget.src = "/assets/images/biling.svg";
            }}
          />
          <span>Settings</span>
        </div>

        {/* 3. Extend Pro / Upgrade Pro */}
        <div
          className="popup-div-upgrade"
          onClick={() => handleNavigate("/Price")}
        >
          <img
            src="/assets/images/upgrade-popup.svg"
            alt="pro"
            width={16}
            height={16}
          />
          <span>{isPro ? "Extend Pro" : "Upgrade Pro"}</span>
        </div>
      </div>
    </div>
  );
}

export default Profilepopup;

